import { useTranslation } from "@equiem/web-ng-lib";
import { Site, useShowError } from "@equiem/web-ng-lib";
import React, { useContext, useState } from "react";
import { useAnonymousLikeMutation } from "../../generated/gateway-client";
import { ContentType } from "../../lib/ContentType";
import { mapContentType } from "../../lib/mapContentType";
import { ThumbsUp } from "../icons/ThumbsUp";
import { Props as RoundButtonProps, RoundButton } from "../RoundButton";

interface Props
  extends Pick<RoundButtonProps, "focusable" | "shadow" | "className"> {
  contentType: ContentType;
  contentUuid: string;
}

export const LikeButton: React.FC<Props> = ({
  className,
  contentUuid,
  contentType,
  focusable,
  shadow,
}) => {
  const { t } = useTranslation();

  const [liked, setLiked] = useState(false);
  const showError = useShowError();
  const [doLike, { loading: liking }] = useAnonymousLikeMutation();
  const mappedContentType = mapContentType(contentType);
  const { uuid: siteUuid } = useContext(Site);

  const sendLike = async () => {
    if (liked) {
      return;
    }

    try {
      const zug = await doLike({
        variables: { siteUuid, contentUuid, contentType: mappedContentType },
      });
      if (zug.data?.anonymousLike !== true) {
        throw new Error();
      }
      setLiked(true);
    } catch (_err) {
      showError(t("main.somethingWentWrongTryAgainError"));
    }
  };

  return (
    <>
      <RoundButton
        loading={liking}
        onToggle={sendLike}
        value={liked}
        className={`btn-like ${className}`}
        shadow={shadow}
        focusable={focusable}
      >
        <ThumbsUp size={22} />
      </RoundButton>
    </>
  );
};;
